import { Instagram, Facebook, MapPin } from "lucide-react";
import { business, hoursDetails } from "@/data/siteData";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#EBE4D8] border-t border-[#132A1C]/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-14">
        <p
          data-testid="footer-closing"
          className="font-serif-display text-2xl md:text-3xl italic text-[#132A1C] max-w-2xl mb-12"
        >
          Thank you for visiting Cafe Anh. <span className="not-italic text-[#5A7365]">Cảm ơn.</span>
        </p>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <a
              href="#top"
              className="font-serif-display text-3xl text-[#132A1C]"
              data-testid="footer-logo"
            >
              Cafe <span className="italic text-[#2C4C3B]">Anh</span>
            </a>
            <p className="mt-3 text-[#2C4C3B] max-w-xs text-[15px] leading-relaxed">
              Vietnamese coffee shop in Helsinki — family-owned, cozy and very welcome
              on Hämeentie 30, {business.neighbourhood}.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] tracking-[0.22em] uppercase text-[#5A7365] mb-3">Visit</p>
            <address className="not-italic text-[#2C4C3B] space-y-1.5 text-[15px]">
              <p>{business.address}</p>
              <p>
                <a href={`tel:${business.phoneTel}`} className="hover:text-[#132A1C] transition-colors">
                  {business.phone}
                </a>
              </p>
              <p>
                <a
                  href={business.mapLink}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-maps-link"
                  className="inline-flex items-center gap-1.5 hover:text-[#132A1C] transition-colors"
                >
                  <MapPin size={13} strokeWidth={1.5} /> Open in Google Maps
                </a>
              </p>
            </address>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] tracking-[0.22em] uppercase text-[#5A7365] mb-3">Hours</p>
            <ul className="text-[#2C4C3B] space-y-1.5 text-[15px]">
              {hoursDetails.map((h) => (
                <li key={h.day} className="flex justify-between gap-3">
                  <span>{h.day}</span>
                  <span className="text-[#5A7365] tabular-nums">{h.time}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2 md:text-right">
            <p className="text-[11px] tracking-[0.22em] uppercase text-[#5A7365] mb-3">Follow</p>
            <div className="flex md:justify-end gap-3">
              <a
                href={business.instagram}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                className="w-11 h-11 flex items-center justify-center border border-[#132A1C]/25 hover:bg-[#132A1C] hover:text-[#F4F0EA] transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={18} strokeWidth={1.5} />
              </a>
              <a
                href={business.facebook}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-facebook"
                className="w-11 h-11 flex items-center justify-center border border-[#132A1C]/25 hover:bg-[#132A1C] hover:text-[#F4F0EA] transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={18} strokeWidth={1.5} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#132A1C]/10 flex flex-col md:flex-row md:items-center justify-between gap-3 text-[12px] text-[#5A7365]">
          <p>© {new Date().getFullYear()} Cafe Anh · Vietnamese coffee shop in Helsinki</p>
          <p className="tracking-[0.18em] uppercase">Cà phê · Phở · Bánh mì</p>
        </div>
      </div>
    </footer>
  );
}
